import EngagementIcon from '@assets/icons/EngagementIcon'
import UnlockIcon from '@assets/icons/UnlockIcon'
import { useApps } from '@auth/useApps'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import ErrorText from '@shared/forms/ErrorText'
import { AppPermission } from '@shared/permissions'
import MessageAndAttachmentsSection from '@tenant/recognition/RecognitionModal/sendRecognitionView/MessageAndAttachmentsSection'
import { RecognitionFormData } from '@tenant/recognition/RecognitionModal/sendRecognitionView/useSendRecognitionForm'
import { T } from '@transifex/react'
import { useFormContext, useWatch } from 'react-hook-form'
import { MobileRecognitionDrawerView } from '../useMobileRecognitionDrawer'
import MobileRecognitionRecipients from './MobileRecognitionRecipients'
import SendRecognitionNavMenuItem from './SendRecognitionNavMenuItem'

const MobileRecognitionSendView = () => {
  const { control, formState } = useFormContext<RecognitionFormData>()
  const qualitiesError = formState.errors.qualities
  const [hasAppPermission] = useApps()
  const recipients = useWatch({ control: control, name: 'sendTo' })

  const canRefineMessage = hasAppPermission(
    'refinementApp',
    AppPermission.RefinementAppRefineRecognition,
  )
  const canUpgradeLicense = hasAppPermission(
    'refinementApp',
    AppPermission.RefinementAppUpgradeLicense,
  )

  return (
    <Stack gap={2}>
      <MobileRecognitionRecipients recipients={recipients} />
      <MessageAndAttachmentsSection
        control={control}
        canRefineMessage={canRefineMessage}
        canUpgradeLicense={canUpgradeLicense}
      />
      <Stack gap={1}>
        <SendRecognitionNavMenuItem
          view={MobileRecognitionDrawerView.QUALITIES}
          icon={<AddCircleOutlineOutlinedIcon />}
          label={<T _str="Add qualities" />}>
          {/* eslint-disable-next-line local/i18n-require-translation-wrappers */}
          <Typography variant="caption">Collaboration + 3</Typography>
        </SendRecognitionNavMenuItem>
        {qualitiesError?.message && <ErrorText>{qualitiesError.message as string}</ErrorText>}
        <SendRecognitionNavMenuItem
          view={MobileRecognitionDrawerView.POINTS}
          icon={<EngagementIcon />}
          label={<T _str="Add points" />}>
          <Typography variant="caption">10</Typography>
        </SendRecognitionNavMenuItem>
        <SendRecognitionNavMenuItem
          view={MobileRecognitionDrawerView.VISIBILITY}
          icon={<UnlockIcon />}
          label={<T _str="Set post visibility" />}>
          {/* eslint-disable-next-line local/i18n-require-translation-wrappers */}
          <Typography variant="caption">Public</Typography>
        </SendRecognitionNavMenuItem>
        <SendRecognitionNavMenuItem
          view={MobileRecognitionDrawerView.SCHEDULE}
          icon={<AccessTimeOutlinedIcon />}
          label={<T _str="Schedule post" />}>
          {/* eslint-disable-next-line local/i18n-require-translation-wrappers */}
          <Typography variant="caption">10:00 AM</Typography>
        </SendRecognitionNavMenuItem>
      </Stack>
    </Stack>
  )
}

export default MobileRecognitionSendView
